<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'app-download-teaser-fi': true,
        'app-download-teaser-fi--with-image': image,
        'app-download-teaser-fi--dark': fields.dark?.value,
      }"
    >
      <div
        :class="{
          'fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12 lg:fi-col-start-3 lg:fi-col-end-11':
            !image,
          'fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12': image,
        }"
      >
        <div class="app-download-teaser-fi__container">
          <div
            :class="{
              'app-download-teaser-fi__text': true,
              'app-download-teaser-fi__text--with-img': image,
            }"
          >
            <richtext-fi :html-content="fields.text" />

            <app-download-buttons-fi
              class="app-download-teaser-fi__buttons"
              :fields="fields"
            />
          </div>
          <div
            v-if="image"
            class="app-download-teaser-fi__image"
          >
            <cloud-image-fi
              v-if="!isEditMode"
              :src="image.src"
              :alt="image.alt"
              params="org_if_sml=1"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-else
              v-html="fields.image.editable"
            />
            <!-- eslint-enable vue/no-v-html -->
          </div>
        </div>
      </div>

      <div class="lg:fi-col-start-7 lg:fi-col-end-12" />
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { RichtextFi } from 'atoms';
import AppDownloadButtonsFi from 'components/app-download-buttons-fi/AppDownloadButtonsFi';
import CloudImageFi from 'components/atoms/cloud-image-fi/CloudImageFi';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';

export default {
  name: 'AppDownloadTeaserFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    RichtextFi,
    CloudImageFi,
    AppDownloadButtonsFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    image() {
      if (this.fields.image?.value?.src) {
        return this.fields.image?.value;
      }

      return false;
    },
  },
};
</script>

<style scoped lang="scss">
@import './app-download-teaser-fi';
</style>
